import { render, staticRenderFns } from "./MyChat.vue?vue&type=template&id=a097521e&"
import script from "./MyChat.vue?vue&type=script&lang=js&"
export * from "./MyChat.vue?vue&type=script&lang=js&"
import style0 from "./MyChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports